export const APP_CONFIG = {
  URL: {
    apiBasePath: `${location.origin}/`,
  },
};
export const LOGIN_PROTECTED = location.host === 'tifowin.com' ? false : true;

export const getHeaders = () => {
  return {
    "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  }
}

export const getTextLogo = () => {
  switch (window.location.host) {
    case 'goalx.me':
    case 'm.goalx.me':
      return 'X';
    case '1xxet.net':
      return '1<i>xxet</i>';
    case 'dubai355.com':
      return 'dubai<i>355</i>';
    case 'scr7.bet':
      return 'bet<i>365</i>';
    case 'dubai365.com':
      return 'dubai<i>365</i>';
    case 'dubaipro365.com':
      return 'dubai<i>365</i>';
    case 'extrabet.net':
      return 'extra<i>bet</i>';
    case 'vipbet-365.com':
      return 'vipbet<i>365</i>';
    case 'ora777.com':
      return 'ora<i>777</i>';
    case 'ora88.com':
      return 'ora<i>88</i>';
    case 'zejbet.com':
      return 'zej<i>bet</i>';
    case 'albbet.co':
      return 'alb<i>bet</i>';
    case 'albbtur.com':
      return 'albb<i>tur</i>';
    case 'slucky24.co':
      return 'lucky<i>24</i>';
    case '1x2corner.com':
    case '1x2over.com':
      return '1x<i>2</i>';
    case 'candapro365.com':
      return 'canada<i>pro</i>';
    case 'max666.bet':
    case 'max777.bet':
      return 'max<i>bet</i>';
    case 'italiasport.co':
    case 'm.italiasport.co':
      return 'italia';
    case 'tifowin.com':
      return 'tifo<i>win</i>';
    case '850bet.co':
    case '850bet.net':
    case '850bet.club':
    case '850bet.bet':
      return '850<i>bet</i>';
    case 'bett3.net':
      return 'bet<i>t3</i>';
    case 'bet777.club':
      return '<i style="color: #000000">bet777</i>';
    default:
      return null;
  }
}

export const getLogo = () => {
  switch (window.location.host) {
    case 'betmania365.co':
      return `data:image/svg+xml;base64,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`;
    case 'jokerbet777.com':
      return `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA4MzkuMiA0OTUuMyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODM5LjIgNDk1LjM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkYwMDAzO30KCS5zdDF7ZmlsbDojMzQzNDM0O30KCS5zdDJ7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTI5MC43LDQ0OC41aDEwMWwzMSwzNmwzMy0zNmg5NWwtMjItNjFsLTU0LDM1YzAsMCwxMDgtMTI2LDI5MC0xODBjMCwwLTEwMi01NC0zMjIsNDljMCwwLDE4LTE5LDM5LTI5bC02MS0xNzQKCWwtNjQsMTc1YzAsMCw3MiwyMiwxMzMsODVjMCwwLTIxNy0xNjUtNDIwLTEwNmMwLDAsMTg2LDQ0LDI4NCwxNzRjMCwwLTIwLTI0LTQwLTMxTDI5MC43LDQ0OC41eiIvPgo8Zz4KCTxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjgwMC43IiBjeT0iMjU3IiByPSIyOSIvPgoJPGVsbGlwc2UgY2xhc3M9InN0MiIgY3g9Ijc5OC43IiBjeT0iMjM5LjUiIHJ4PSIxMi41IiByeT0iNi41Ii8+CjwvZz4KPGc+Cgk8Y2lyY2xlIGNsYXNzPSJzdDEiIGN4PSI0MTkuMiIgY3k9IjQzIiByPSIyOSIvPgoJPGVsbGlwc2UgY2xhc3M9InN0MiIgY3g9IjQxNy4yIiBjeT0iMjUuNSIgcng9IjEyLjUiIHJ5PSI2LjUiLz4KPC9nPgo8Zz4KCTxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjM1LjciIGN5PSIyNTciIHI9IjI5Ii8+Cgk8ZWxsaXBzZSBjbGFzcz0ic3QyIiBjeD0iMzMuNyIgY3k9IjIzOS41IiByeD0iMTIuNSIgcnk9IjYuNSIvPgo8L2c+Cjwvc3ZnPgo=`;
    case 'lucky333.co':
      return '../src/img/lucky333.png';
    case 'lion07.bet':
      return '../src/img/lion07-logo.svg';
    case 'lemon777.co':
    case 'lemon777.pro':
      return '../src/img/lemon-logo.png';
    case 'maxbet.run':
    case 'm.maxbet.run':
      return '../src/img/maxbet-logo.svg';
    case 'mdcr7.co':
      return '../src/img/b3t-logo.svg';
    case 'b3tcr7.com':
      return '../src/img/b3t-black.svg';
    case 'goldenbet.gs':
    case 'localhost:8080':
      return '../src/img/golden-bet-logo.svg';
    case 'bastalbania.co':
    case 'bastalbania.com':
    case 'bastalbania.net':
      return '../src/img/bastalbania-logo.svg';
    // case 'scr7.bet':
    //   return '../src/img/cr7-logo.png';
    default:
      return '../src/img/xbet-logo.svg';
  }
}

export const getTitle = () => {
  switch (window.location.host) {
    case 'goalx.me':
    case 'm.goalx.me':
    case '1xxet.net':
    case 'localhost:8080':
      return 'X';
    case 'betmania365.co':
      return 'betmania365';
    case 'lion07.bet':
      return 'lion07';
    case 'maxbet.run':
    case 'm.maxbet.run':
      return 'maxbet';
    case 'albbet.co':
      return 'albbet';
    case 'slucky24.co':
      return 'lucky24';
    case '1x2corner.com':
    case '1x2over.com':
      return '860bet';
    case 'max666.bet':
    case 'max777.bet':
      return 'maxbet';
    case 'candapro365.com':
      return 'canadapro365';
    case 'scr7.bet':
      return 'bet365';
    case 'italiasport.co':
    case 'm.italiasport.co':
      return 'italiasport';
    case 'tifowin.com':
      return 'tifowin';
    case '850bet.net':
    case '850bet.co':
    case '850bet.club':
    case '850bet.bet':
      return '850bet';
    case 'albbtur.com':
      return 'albbtur';
    case 'bett3.net':
      return 'bett3';
    case 'bet777.club':
      return 'bet777';
    case 'mdcr7.co':
      return 'mdcr7';
    case 'b3tcr7.com':
      return 'CR7';
    case 'goldenbet.gs':
      return 'GoldenBet';
    case 'bastalbania.co':
    case 'bastalbania.com':
    case 'bastalbania.net':
      return 'bast';
    default:
      return 'xbet';
  }
}
